import {h, render} from 'preact';
import User from '@modules/User';
import ProductSearch from './components/search/ProductSearch';
import Provider from 'preact-context-provider';

const SearchSuggestions = {
    init () {
        const searchBoxWrapper = this.searchBoxWrapper = document.getElementById( 'search-bar-wrapper--header' );

        if ( searchBoxWrapper ) {
            const inp = searchBoxWrapper.querySelector( 'input[type="text"]' );
            searchBoxWrapper.innerHTML = '';

            render(
                <Provider siteConfig={upi.conf}>
                    <ProductSearch
                        initialQuery={inp && inp.value || ''}
                        showAllSkus={User.isTamProxy()}
                        showBrandFamily={true}
                    >
                        {() =>
                            <div>
                                <div id="search-bar--header"
                                     className="flex w-full lg:flex-1 p-2 md:p-0 border-b border-solid border-grey-light md:border-none">
                                    <ProductSearch.Input/>
                                    <span data-action="search-bar-toggle--mobile"
                                          className="md:hidden px-2 self-center text-lg text-sky-blue">Cancel</span>
                                </div>
                                <ProductSearch.Results>
                                    {results =>
                                        <ProductSearch.ResultsPane>{results}</ProductSearch.ResultsPane>
                                    }
                                </ProductSearch.Results>
                            </div>
                        }
                    </ProductSearch>
                </Provider>,
                searchBoxWrapper
            );

        }
        else {
            console.warn( 'Could not mount <Search/> component; Root node #SearchBox not found' );
        }
    }
};

export default SearchSuggestions;


